export default Object.freeze({
  KILOGRAM: 'kg',
  GRAM: 'g',
  MILIGRAM: 'mg',
});
